import * as React from 'react';
const Report = (props: React.SVGProps<SVGSVGElement>) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		viewBox="0 0 16 20"
		fill="none"
		{...props}
	>
		<path
			fill="#fff"
			d="M10 0H2C.9 0 0 .9 0 2v16c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V6l-6-6Zm4 18H2V2h7v5h5v11Zm-9-7v6H3v-6h2Zm6 2v4h2v-4h-2ZM7 9v8h2V9H7Z"
		/>
	</svg>
);
export default Report;
